import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AccessGaurdService } from "./services/access-gaurd.service";
import { ThemeComponent } from "./theme.component";

const routes: Routes = [
    {
        path: "",
        component: ThemeComponent,
        children: [
            {
                path: "",
                loadChildren:
                    "./pages/default/project_select/project_select.module#ProjectSelectModule",
            },

            {
                path: "dashboard",
                loadChildren: "./pages/default/index/index.module#IndexModule",
            },
            {
                path: "group_setup",
                loadChildren:
                    "./pages/default/group_setup/group_setup.module#GroupSetupModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "company_setup",
                loadChildren:
                    "./pages/default/company_setup/company.module#CompanyModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "company_list",
                loadChildren:
                    "./pages/default/company_list/companyList.module#CompanyListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "business_unit_setup",
                loadChildren:
                    "./pages/default/business_unit_setup/unit.module#UnitModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "business_unit_list",
                loadChildren:
                    "./pages/default/business_unit_list/business_unit_list.module#BusinessUnitListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "designation_master",
                loadChildren:
                    "./pages/default/designation/designation.module#DesignationModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "designation_list",
                loadChildren:
                    "./pages/default/designation_list/designationList.module#DesignationListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "equivalent_designation",
                loadChildren:
                    "./pages/default/equivalent_designation/equivalent_designation.module#EquivalentDesignationModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "equivalent_designation_list",
                loadChildren:
                    "./pages/default/equivalent_designation_list/equivalentDesignationList.module#EquivalentDesignationListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "department_setup",
                loadChildren:
                    "./pages/default/department_setup/department_setup.module#DepartmentSetupModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "department_list",
                loadChildren:
                    "./pages/default/department_list/department_list.module#DepartmentListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "grade_master",
                loadChildren:
                    "./pages/default/grademaster/grademaster.module#GradeMasterModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "grade_list",
                loadChildren:
                    "./pages/default/gradelist/gradelist.module#GradeListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "prefix_master/:id",
                loadChildren:
                    "./pages/default/prefix_master/prefix_master.module#PrefixMasterModule",
            },
            {
                path: "prefix_list",
                loadChildren:
                    "./pages/default/prefix_list/prefix_list.module#PrefixListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "employee/employeeshifting",
                loadChildren:
                    "./pages/default/employee/employee_shifting/employeeShifting.module#EmployeeShiftingModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "shift_entry",
                loadChildren:
                    "./pages/default/shift_entry/shift-entry.module#ShiftEntryModule",
            },
            {
                path: "employee/employeeshiftlist",
                loadChildren:
                    "./pages/default/employee/employeeshiftlist/employeeshiftlist.module#EmployeeShiftListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "cost_center/list",
                loadChildren:
                    "./pages/default/cost_center_list/costCenterList.module#CostCenterListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "bank/list",
                loadChildren:
                    "./pages/default/bank_list/bankList.module#BankListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "branch/setup",
                loadChildren:
                    "./pages/default/bank_branch_master/branch_master.module#BranchMasterModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "branch/list",
                loadChildren:
                    "./pages/default/bank_branch_list/branchList.module#BranchListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "work_station/setup",
                loadChildren:
                    "./pages/default/work_station/work_station.module#WorkStationModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "work_station/list",
                loadChildren:
                    "./pages/default/work_station_list/workStationList.module#WorkStationListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "emp_nature_type",
                loadChildren:
                    "./pages/default/emp_nature_type/emp_nature_type.module#EmpNatureTypeModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "emp_nature_types",
                loadChildren:
                    "./pages/default/emp_nature_types/emp_nature_types.module#EmpNatureTypesModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "weekend_setup",
                loadChildren:
                    "./pages/default/weekend_setup/weekend_setup.module#WeekendSetupModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "leave_year_setup",
                loadChildren:
                    "./pages/default/leave_year_setup/leaveYear.module#LeaveYearSetupModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "monthly_leave_setup",
                loadChildren:
                    "./pages/default/monthly_leave_setup/monthly-leave-setup.module#MonthlyLeaveSetupModule",
            },
            {
                path: "calendar_setup",
                loadChildren:
                    "./pages/default/calendar_setup/calendar-setup.module#CalendarSetupModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "absent_template",
                loadChildren:
                    "./pages/default/absent_template/absentSetup.module#AbsentSetupModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "absent_template_list",
                loadChildren:
                    "./pages/default/absent_template_list/absentTemplateList.module#AbsentTemplateListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "absent_setup",
                loadChildren:
                    "./pages/default/absent_setup/absentSetupToProject.module#AbsentSetupToProjectModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "leave_policy_template",
                loadChildren:
                    "./pages/default/leave_policy_template/leave_policy_template.module#LeavePolicyTemplateModule",
                // "canActivate": [AccessGaurdService]
            },
            {
                path: "leave_policy_template_list",
                loadChildren:
                    "./pages/default/leave_policy_template_list/leavePolicyTemplateList.module#LeavePolicyTemplateListModule",
                // "canActivate": [AccessGaurdService]
            },
            {
                path: "holiday_type/setup",
                loadChildren:
                    "./pages/default/holiday_type/holidayType.module#HolidayTypeModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "holidays_setup",
                loadChildren:
                    "./pages/default/holidays_setup/holidays_setup.module#HolidaysSetupModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "holidays_setup_list",
                loadChildren:
                    "./pages/default/holidays_setup_list/holidays_setup_list.module#HolidaysSetupListModule",
                // canActivate: [AccessGaurdService],
            },
            {
                path: "holidays_list",
                loadChildren:
                    "./pages/default/holidays_list/holidays_list.module#HolidaysListModule",
                // canActivate: [AccessGaurdService],
            },
            {
                path: "employee/create_employee/personal/:id",
                loadChildren:
                    "./pages/default/employee/create_employee/personal/personal.module#PersonalModule",
            },
            {
                path: "employee/create_employee/education_info/:id",
                loadChildren:
                    "./pages/default/employee/create_employee/education_info/education_info.module#EducationInfoModule",
                // "canActivate": [AccessGaurdService]
            },
            {
                path: "employee/create_employee/training_certification/:id",
                loadChildren:
                    "./pages/default/employee/create_employee/training_certification_info/trainingCertificationInfo.module#TrainingCertificationInfoModule",
                // "canActivate": [AccessGaurdService]
            },
            {
                path: "employee/create_employee/experience/:id",
                loadChildren:
                    "./pages/default/employee/create_employee/experience/experience.module#ExperienceModule",
            },
            {
                path: "employee/create_employee/personal_list",
                loadChildren:
                    "./pages/default/employee/create_employee/personal_list/personal_list.module#PersonalListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "employee_excel_import",
                loadChildren:
                    "./pages/default/employee_excel_import/employee_excel_import.module#EmployeeExcelModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "organization/setup/:id",
                loadChildren:
                    "./pages/default/organization_info/organizationInfo.module#OrganizationInfoModule",
                // "canActivate": [AccessGaurdService]
            },
            {
                path: "organization/list",
                loadChildren:
                    "./pages/default/organization_list/organizationList.module#OrganizationListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "organization/weekend_setup",
                loadChildren:
                    "./pages/default/employee_weekend_setup/employee_weekend_setup.module#EmployeeWeekendSetupModule",
            },
            {
                path: "organization/supervisor_replace",
                loadChildren:
                    "./pages/default/supervisor_replace/supervisorReplace.module#SupervisorReplaceModule",
            },
            {
                path: "employee/transfer",
                loadChildren:
                    "./pages/default/employee/employeetransfer/employeetransfer.module#EmployeeTransferModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "pending-transfers",
                loadChildren:
                    "./pages/default/pending_transfers/pending-transfers.module#PendingTransfersModule",
            },
            {
                path: "transfer/list",
                loadChildren:
                    "./pages/default/employee/employeetransferlist/transferlist.module#TransferListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "employee/promotion",
                loadChildren:
                    "./pages/default/employee/employee_promotion/employee_promotion.module#EmployeePromotionModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "promotion/list",
                loadChildren:
                    "./pages/default/employee/employee_promotion_list/employee_promotion_list.module#EmployeePromotionListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "earning_heads/setup",
                loadChildren:
                    "./pages/default/earning_heads/earningHeads.module#EarningHeadsModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "earning_heads/list",
                loadChildren:
                    "./pages/default/earning_heads_list/earningHeadList.module#EarningHeadListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "deduction_heads/setup",
                loadChildren:
                    "./pages/default/deduction_heads/deductionHeads.module#DeductionHeadsModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "deduction_heads/list",
                loadChildren:
                    "./pages/default/deduction_heads_list/deductionHeadList.module#DeductionHeadListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "pay_structure_template/setup",
                loadChildren:
                    "./pages/default/pay_structure_template/payStructureTemplate.module#PayStructureTemplateModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "pay_structure_template/list",
                loadChildren:
                    "./pages/default/pay_structure_template_list/templateDetailsList.module#TemplateDetailsListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "pay_structure/setup",
                loadChildren:
                    "./pages/default/pay_structure_setup/payStructureSetup.module#PayStructureSetupModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "increment_entry",
                loadChildren:
                    "./pages/default/increment_entry/incrementEntry.module#IncrementEntryModule",
                // canActivate: [AccessGaurdService],
            },
            {
                path: "pay_structure/list",
                loadChildren:
                    "./pages/default/pay_structure_list/payStructureList.module#PayStructureListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "pay_structure/resigned_list",
                loadChildren:
                    "./pages/default/pay_structure_resigned_list/payStructureResignedList.module#PayStructureResignedListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "bonus/setup",
                loadChildren:
                    "./pages/default/bonus_setup/bonusSetup.module#BonusSetupModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "bonus/list_employee",
                loadChildren:
                    "./pages/default/bonus_list/bonusList.module#BonusListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "bonus/list_project",
                loadChildren:
                    "./pages/default/bonus_list_project/projectBonusList.module#ProjectBonusListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "pay_structure/variable_input",
                loadChildren:
                    "./pages/default/pay_structure_variable_input/payStructureVariableInput.module#PayStructureVariableInputModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "pay_structure/holding_heads",
                loadChildren:
                    "./pages/default/pay_structure_holding_heads/payStructureHoldingHeads.module#PayStructureHoldingHeadsModule",
                // "canActivate": [AccessGaurdService]
            },
            {
                path: "holding_heads/list",
                loadChildren:
                    "./pages/default/holding_head_list/holdingHeadsList.module#HoldingHeadsListModule",
                // "canActivate": [AccessGaurdService]
            },
            {
                path: "variable_input/list",
                loadChildren:
                    "./pages/default/variable_input_list/variableInputList.module#VariableInputListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "pay_slip_generation/setup",
                loadChildren:
                    "./pages/default/pay_slip_generation/paySlipGenerationSetup.module#PaySlipGenerationSetupModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "final_settlement",
                loadChildren:
                    "./pages/default/final_settlement/finalSettlement.module#FinalSettlementModule",
                canActivate: [AccessGaurdService],
            },
                    {
                        path: "final_settlement_list",
                        loadChildren:
                            "./pages/default/final_settlement_list/finalSettlementList.module#FinalSettlementListModule",
                        canActivate: [AccessGaurdService],
                    },
                    {
                        path: "supplimentary_salary",
                        loadChildren:
                            "./pages/default/supplimentary_salary/supplimentarySalary.module#SupplimentarySalaryModule",
                        canActivate: [AccessGaurdService],
                    },
                    {
                        path: "supplimentary_salary_list",
                        loadChildren:
                            "./pages/default/supplimentary_salary_list/supplimentarySalaryList.module#SupplimentarySalaryListModule",
                        canActivate: [AccessGaurdService],
                    },
            {
                path: "leavetype_setup",
                loadChildren:
                    "./pages/default/leavetype_setup/leavetype_setup.module#LeaveTypeSetupModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "leavetype_list",
                loadChildren:
                    "./pages/default/leavetype_list/leavetype_list.module#LeavetypeListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "regular_leave_balance_import",
                loadChildren:
                    "./pages/default/regular_leave_balance_import/regularLeaveBalanceImport.module#RegularLeaveBalanceImportModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "monthly_leave_balance_import",
                loadChildren:
                    "./pages/default/monthly_leave_balance_import/monthlyLeaveBalanceImport.module#MonthlyLeaveBalanceImportModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "leaveapplication",
                loadChildren:
                    "./pages/default/leaveapplication/leaveapplication.module#LeaveApplicationModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "leave_calculation",
                loadChildren:
                    "./pages/default/leave_calculation/leave-calculation.module#LeaveCalculationModule",
            },
            {
                path: "leaveapplication_list",
                loadChildren:
                    "./pages/default/leaveapplication_list/leaveapplication_list.module#LeaveApplicationListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "leave_encashment_setup",
                loadChildren:
                    "./pages/default/leave_encashment_setup/leave_encashment_setup.module#LeaveEncashmentSetupModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "leave_encashment_setup_list",
                loadChildren:
                    "./pages/default/leave_encashment_setup_list/leave_encashment_setup_list.module#LeaveEncashmentListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "leave_encashment_generation",
                loadChildren:
                    "./pages/default/leave_encashment_generation/leave_encashment_generation.module#LeaveEncashmentGenerationModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "leave_encashment_history",
                loadChildren:
                    "./pages/default/leave_encashment_history/leave_encashment_history.module#LeaveEncashmentHistoryModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "attendance_calendar",
                loadChildren:
                    "./pages/default/attendance_calendar/attendance_calendar.module#AttendanceCalendarModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "attendance_file_import",
                loadChildren:
                    "./pages/default/attendance_file_import/attendance_file_import.module#AttendanceFileImportModule",
                // "canActivate": [AccessGaurdService]
            },
            {
                path: "attendance_history_monthly",
                loadChildren:
                    "./pages/default/attendance_history_monthly/attendance_history_monthly.module#AttendanceHistoryMonthlyModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "attendance_manual",
                loadChildren:
                    "./pages/default/attendance_manual/attendance_manual.module#AttendanceManualModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "absent_entry",
                loadChildren:
                    "./pages/default/absent_entry/absent-entry.module#AbsentEntryModule",
            },
            {
                path: "attendance_history",
                loadChildren:
                    "./pages/default/attendance_history/attendance_history.module#AttendanceHistoryModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "roster_plan",
                loadChildren:
                    "./pages/default/roster_plan/roster_plan.module#RosterPlanModule",
                // canActivate: [AccessGaurdService],
            },
            {
                path: "roster_plan_list",
                loadChildren:
                    "./pages/default/roster_plan_list/roster_plan_list.module#RosterPlanListModule",
                // canActivate: [AccessGaurdService],
            },
            {
                path: "attendance_logs",
                loadChildren:
                    "./pages/default/attendance_logs/attendance_logs.module#AttendanceLogsModule",
            },
            {
                path: "outstation_entry",
                loadChildren:
                    "./pages/default/outstation/outstation_entry/outstation_entry.module#OutstationEntryModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "outstation_list",
                loadChildren:
                    "./pages/default/outstation/outstation_list/outstation_list.module#OutstationListModule",
                // canActivate: [AccessGaurdService],
            },
            {
                path: "attendance_calculation",
                loadChildren:
                    "./pages/default/attendance_calculation/attendanceCalculation.module#AttendanceCalculationModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "advance_payment_setup",
                loadChildren:
                    "./pages/default/advance_payment_setup/advance.module#AdvanceModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "advance_template_setup_list",
                loadChildren:
                    "./pages/default/advance_template_setup_list/advance_template_setup_list.module#AdvanceTemplateSetupListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "advance_payment",
                loadChildren:
                    "./pages/default/advance_payment/advance_payment.module#AdvancePaymentModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "advance_history",
                loadChildren:
                    "./pages/default/advance_history/advance_history.module#AdvanceHistoryModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "advance_payment_hold",
                loadChildren:
                    "./pages/default/advance_payment_hold/advance_payment_hold.module#AdvancePaymentHoldModule",
            },
            {
                path: "advance_cut",
                loadChildren:
                    "./pages/default/advance_cut/advance_cut.module#AdvanceCutModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "earlysettlement",
                loadChildren:
                    "./pages/default/earlysettlement/earlysettlement.module#EarlysettlementModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "overtime_template_setup",
                loadChildren:
                    "./pages/default/overtime_template_setup/overtime_template_setup.module#OvertimeTemplateSetupModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "overtime_template_list",
                loadChildren:
                    "./pages/default/overtime_template_list/overTimeTemplateList.module#OverTimeTemplateListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "overtime/:id",
                loadChildren: "./pages/default/overtime/overtime.module#OvertimeModule",
            },
            {
                path: "overtime_list",
                loadChildren:
                    "./pages/default/overtime_list/overtime_list.module#OvertimeListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "manual_overtime_calendar/:id/:month/:year",
                loadChildren:
                    "./pages/default/manual_overtime_calendar/manual_overtime_calendar.module#ManualOvertimeCalendarModule",
                // "canActivate": [AccessGaurdService]
            },
            {
                path: "manual_overtime_list",
                loadChildren:
                    "./pages/default/manual_overtime_list/manual_overtime_list.module#ManualOvertimeListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "monthly_overtime_entry",
                loadChildren:
                    "./pages/default/monthly_overtime_entry/monthlyOvertimeEntry.module#MonthlyOvertimeEntryModule",
            },
            {
                path: "overtime_monthly_entry_list",
                loadChildren:
                    "./pages/default/overtime_monthly_entry_list/overtimeMonthlyEntryList.module#OverTimeMonthlyEntryListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "present_offday_template",
                loadChildren:
                    "./pages/default/present_offday_template/presentOffDayTemplate.module#PresentOffDayTemplateModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "present_offday_template_list",
                loadChildren:
                    "./pages/default/present_offday_template_list/presentOffdayTemplateList.module#PresentOffdayTemplateListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "present_offday_setup",
                loadChildren:
                    "./pages/default/present_offday_setup/present_offday_setup.module#PresentOffdaySetupModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "present_offday_list",
                loadChildren:
                    "./pages/default/present_offday_list/present_offday_list.module#PresentOffdayListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "monthly_po_entry",
                loadChildren:
                    "./pages/default/monthly_po_entry/monthlyPOEntry.module#MonthlyPOEntryModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "present_offday_monthly_entry_list",
                loadChildren:
                    "./pages/default/present_offday_monthly_entry_list/presentOffdayMonthlyEntryList.module#PresentOffdayMonthlyEntryListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "compensatory_leave_setup",
                loadChildren:
                    "./pages/default/compensatory_leave_setup/compensatory_leave_setup.module#CompensatoryLeaveSetupModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "compensatory_list",
                loadChildren:
                    "./pages/default/compensatory_list/compensatory_list.module#CompensatoryListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "night_stay_template",
                loadChildren:
                    "./pages/default/nightstay_template/overstayTemplate.module#OverstayTemplateModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "night_stay_template_list",
                loadChildren:
                    "./pages/default/night_stay_template_list/nightStayTemplateList.module#NightStayTemplateListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "night_stay_setup",
                loadChildren:
                    "./pages/default/nightstay_setup/nightStaySetup.module#NightStaySetupModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "night_stay_list",
                loadChildren:
                    "./pages/default/over_stay_list/over_stay_list.module#OverStayListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "monthly_night_stay_entry",
                loadChildren:
                    "./pages/default/monthly_overstay_entry/monthlyOverstayEntry.module#MonthlyOverStayEntryModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "night_stay_monthly_entry_list",
                loadChildren:
                    "./pages/default/night_stay_monthly_entry_list/nightStayMonthlyEntryList.module#NightStayMonthlyEntryListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "reports/setup_report",
                loadChildren:
                    "./pages/default/reports/setup_report/setupReport.module#SetupReportModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "reports/central_report",
                loadChildren:
                    "./pages/default/reports/central_report/centralReport.module#CentralReportModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "reports/employee_report",
                loadChildren:
                    "./pages/default/reports/employee_report/employeeReport.module#EmployeeReportModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "reports/overall_report",
                loadChildren:
                    "./pages/default/reports/overall_report/overall_report.module#OverallReportModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "reports/entry_report",
                loadChildren:
                    "./pages/default/reports/entry_report/entryReport.module#EntryReportModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "reports/attendance_report",
                loadChildren:
                    "./pages/default/reports/attendance_report/attendanceReport.module#AttendanceReportModule",
                // canActivate: [AccessGaurdService],
            },
            {
                path: "reports/habitual_report",
                loadChildren:
                    "./pages/default/reports/habitual_report/habitualReport.module#HabitualReportModule",
            },
            {
                path: "reports/remarks_report",
                loadChildren:
                    "./pages/default/reports/remarks_report/remarksReport.module#RemarksReportModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "employee/create_employee/personal_list_report",
                loadChildren:
                    "./pages/default/employee/create_employee/personal_list/personal_list.module#PersonalListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "organization/list_report",
                loadChildren:
                    "./pages/default/organization_list/organizationList.module#OrganizationListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "pay_structure/list_report",
                loadChildren:
                    "./pages/default/pay_structure_list/payStructureList.module#PayStructureListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "pay_slip_generation/list_employee_report",
                loadChildren:
                    "./pages/default/pay_slip_generation_details_list/generatedDetailsList.module#GeneratedDetailsListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "pay_slip_generation/list_project_report",
                loadChildren:
                    "./pages/default/pay_slip_list_project/projectPaySlipList.module#ProjectPaySlipListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "pay_slip_list_workstation",
                loadChildren:
                    "./pages/default/pay_slip_list_workstation/workstationPaySlipList.module#workstationPaySlipListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "reports/monthly_salary_statement_report",
                loadChildren:
                    "./pages/default/reports/monthly_salary_statement/monthly_salary_statement.module#MonthlySalSatModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "reports/monthly_salary_statement_cash",
                loadChildren:
                    "./pages/default/reports/monthly_salary_statement_cash/monthlySalaryStatementCash.module#MonthlySalSatCashModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "reports/variable_input",
                loadChildren:
                    "./pages/default/variable_input_report/variableInputReport.module#VariableInputReportModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "leave_policy_list_report",
                loadChildren:
                    "./pages/default/leave_policy_list/leave_policy_list.module#LeavePolicyListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "leave_balance_report",
                loadChildren:
                    "./pages/default/leave_balance_report/leaveBalanceReport.module#LeaveBalanceReportModule",
            },
            {
                path: "leave_balance_list_report",
                loadChildren:
                    "./pages/default/leave_balance_list/leave_balance_list.module#LeaveBalanceListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "leaveapplication_list_report",
                loadChildren:
                    "./pages/default/leaveapplication_list/leaveapplication_list.module#LeaveApplicationListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "leaveapplication_list_summary_report",
                loadChildren:
                    "./pages/default/leaveapplication_list_summarry/leaveapplication_list_summarry.module#LeaveApplicationListSummaryModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "leave_encashment_setup_list_report",
                loadChildren:
                    "./pages/default/leave_encashment_setup_list/leave_encashment_setup_list.module#LeaveEncashmentListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "attendance_history_monthly_report",
                loadChildren:
                    "./pages/default/attendance_history_monthly/attendance_history_monthly.module#AttendanceHistoryMonthlyModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "manual_overtime_list_report",
                loadChildren:
                    "./pages/default/manual_overtime_list/manual_overtime_list.module#ManualOvertimeListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "advance_history_report",
                loadChildren:
                    "./pages/default/advance_report/advance-report.module#AdvanceReportModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "earlysettlement_report",
                loadChildren:
                    "./pages/default/earlysettlement/earlysettlement.module#EarlysettlementModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "holidays_list_report",
                loadChildren:
                    "./pages/default/holidays_list/holidays_list.module#HolidaysListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "present_offday_list_report",
                loadChildren:
                    "./pages/default/present_offday_list/present_offday_list.module#PresentOffdayListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "transfer/list_report",
                loadChildren:
                    "./pages/default/transfer_list/transferList.module#TransferListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "accounting_setup",
                loadChildren:
                    "./pages/default/accounting_setup/accounting_setup.module#AccountingSetupModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "accounting_posting/payslip",
                loadChildren:
                    "./pages/default/accounting_posting/with-payslip/with_payslip_posting.module#AccountingPostingModule",
                // canActivate: [AccessGaurdService],
            },
            {
                path: "accounting_posting/without_payslip",
                loadChildren:
                    "./pages/default/accounting_posting/without-payslip/without_payslip_posting.module#AccountingPostingModule",
                // canActivate: [AccessGaurdService],
            },
            {
                path: "accounting_posting_list",
                loadChildren:
                    "./pages/default/accounting_posting_list/accountingPostingList.module#AccountingPostingListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "accounting_payslip_payment",
                loadChildren:
                    "./pages/default/accounting_payslip_payment/payslip-payment.module#AccountingPayslipPaymentModule",
            },
            {
                path: "accounting_payslip_payment_list",
                loadChildren:
                    "./pages/default/accounting_payslip_payment_list/payslip-payment-list.module#PayslipPaymentListModule",
            },
            {
                path: "accounts_payments",
                loadChildren:
                    "./pages/default/accounts_payment_list/accounts-payment-list.module#AccountsPaymentListModule",
                // "canActivate": [AccessGaurdService]
            },
            {
                path: "pay_slip_generation/list_accounts_report",
                loadChildren:
                    "./pages/default/pay_slip_generation_accounts_details_list/employeeWise/generatedDetailsList.module#GeneratedDetailsListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "employee_bonus_list_accounts",
                loadChildren:
                    "./pages/default/bonus_list_accounts/employeeWiseBonus/bonusListAccounts.module#EmployeeBonusListAccountsModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "employee_present_offday_list_accounts",
                loadChildren:
                    "./pages/default/accounts_present_offday_list/employeeWise/accounts_present_offday_list.module#AccountsEmployeePresentOffdayListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "employee_night_stay_list_accounts",
                loadChildren:
                    "./pages/default/accounts_night_stay_list/employeeWise/accounts_night_stay_list.module#AccountsEmployeeNightStayListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "employee_overtime_list_accounts",
                loadChildren:
                    "./pages/default/accounts_overtime_list/employeeWise/accounts_overtime_list.module#AccountsOvertimeEmployeeListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "employee_encashment_list_accounts",
                loadChildren:
                    "./pages/default/accounts_leave_encashment/employeeWise/accounts_leave_encashment.module#AccountsLeaveEncashmentModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "advance_payment_list_accounts",
                loadChildren:
                    "./pages/default/advance_history_accounts/advance_history_accounts.module#AdvanceHistoryAccountsModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "accounts_final_settlement",
                loadChildren:
                    "./pages/default/accounts_final_settlement/accounts_final_settlement.module#AccountsFinalSettlementModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "pay_slip_generation/list_accounts_report_monthly",
                loadChildren:
                    "./pages/default/pay_slip_generation_accounts_details_list/projectWise/generatedDetailsList.module#GeneratedDetailsListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "project_bonus_list_accounts",
                loadChildren:
                    "./pages/default/bonus_list_accounts/projectWiseBonus/bonusListAccounts.module#ProjectBonusListAccountsModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "project_present_offday_list_accounts",
                loadChildren:
                    "./pages/default/accounts_present_offday_list/projectWise/accounts_present_offday_list.module#AccountsProjectPresentOffdayListModule",
                canActivate: [AccessGaurdService],
            },

            {
                path: "monthly_night_stay_list_accounts",
                loadChildren:
                    "./pages/default/accounts_night_stay_list/projectWise/accounts_night_stay_list.module#AccountsProjectNightStayListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "project_overtime_list_accounts",
                loadChildren:
                    "./pages/default/accounts_overtime_list/projectWise/accounts_overtime_list.module#AccountsOvertimeProjectListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "project_encashment_list_accounts",
                loadChildren:
                    "./pages/default/accounts_leave_encashment/projectWise/accounts_leave_encashment.module#AccountsLeaveEncashmentModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "cost_center/setup",
                loadChildren:
                    "./pages/default/budget_cost_center/budgetCostCenter.module#BudgetCostCenterModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "project_access",
                loadChildren:
                    "./pages/default/project_access/project_access.module#ProjectAccessModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "access_list",
                loadChildren:
                    "./pages/default/access_list/access_list.module#AccessListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "denomination_master",
                loadChildren:
                    "./pages/default/denomination_master/denominationMaster.module#DenominationMasterModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "denomination_list",
                loadChildren:
                    "./pages/default/denomination_list/denominationList.module#DenominationListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "reports/denomination_report",
                loadChildren:
                    "./pages/default/reports/denomination_report/denominationReport.module#DenominationReportModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "reports/common_report",
                loadChildren:
                    "./pages/default/reports/common_report/commonReport.module#CommonReportModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "reports/provident_fund_report",
                loadChildren:
                    "./pages/default/reports/provident_fund_report/providentFundReport.module#ProvidentFundModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "reports/salary_tds_report",
                loadChildren:
                    "./pages/default/reports/salary_tds_report/salaryTdsReport.module#SalaryTdsReportModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "reports/demo_report",
                loadChildren:
                    "./pages/default/reports/demo_report/demo-report.module#DemoReportModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "reports/employee_count_data_report",
                loadChildren:
                    "./pages/default/reports/employee_count_data_report/employeeCountDataReport.module#EmployeeCountDataReportModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "project_wise_employee_list",
                loadChildren:
                    "./pages/default/project_wise_employee_list/projectWiseEmployeeList.module#ProjectWiseEmployeeListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "salary_holdup_employee_list",
                loadChildren:
                    "./pages/default/salary_holdup_employee_list/salaryHoldupEmployeeList.module#SalaryHoldupEmployeeListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "project_wise_template_assign",
                loadChildren:
                    "./pages/default/project_wise_template_assign/projectwiseTemplateAssign.module#ProjectwiseTemplateAssignModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "project_wise_template_assign_list",
                loadChildren:
                    "./pages/default/project_wise_template_assign_list/projectwiseTemplateAssignList.module#ProjectwiseTemplateAssignListModule",
                //"canActivate": [AccessGaurdService]
            },
            /*  Extra Links */
            {
                path: "job_requisition",
                loadChildren:
                    "./pages/default/job_requisition/jobRequisition.module#JobRequisitionModule",
            },
            {
                path: "covid_deduction",
                loadChildren:
                    "./pages/default/covid_deduction/covid_deduction.module#CovidDeductionModule",
            },
            {
                path: "organization_individual_edit/:id",
                loadChildren:
                    "./pages/default/organization_individual_edit/organizationIndividualEdit.module#OrganizationIndividualEditModule",
            },
            // {
            //   path: "absent_template",
            //   loadChildren:
            //     "./pages/default/absent_template/absentSetup.module#AbsentSetupModule",
            // },
            // {
            //   path: "absent_setup",
            //   loadChildren:
            //     "./pages/default/absent_setup/absentSetupToProject.module#AbsentSetupToProjectModule",
            // },
            // {
            //     "path": "attendance_calendar",
            //     "loadChildren": ".\/pages\/default\/calendar-external-events\/calendar-external-events.module#CalendarExternalEventsModule",
            //     "canActivate": [AccessGaurdService],
            // },
            // {
            //     "path": "user_access",
            //     "loadChildren": ".\/pages\/default\/user_access\/user_access.module#UserAccessModule",
            //     "canActivate": [AccessGaurdService]
            // },
            {
                path: "late_present_setup",
                loadChildren:
                    "./pages/default/late_present_setup/late_present_setup.module#LatePresentSetupModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "employee/permanentize",
                loadChildren:
                    "./pages/default/employee/employee_permanentize/employeePermanentize.module#EmployeePermanentizeModule",
                // "canActivate": [AccessGaurdService]
            },
            {
                path: "employee/contract_list",
                loadChildren:
                    "./pages/default/employee/employee_contract_list/employeeContractList.module#EmployeeContractListModule",
                // "canActivate": [AccessGaurdService]
            },
            {
                path: "employee/contract",
                loadChildren:
                    "./pages/default/employee/employee_contract/employeeContract.module#EmployeeContractModule",
                // "canActivate": [AccessGaurdService]
            },
            {
                path: "employee/remarks",
                loadChildren:
                    "./pages/default/employee/employee_remarks/employeeRemarks.module#EmployeeRemarksModule",
                // canActivate: [AccessGaurdService],
            },
            {
                path: "employee/remarks-list",
                loadChildren:
                    "./pages/default/employee/employee_remarks_list/employee_remarks_list.module#EmployeeRemarksListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "pms/appraiser/setup",
                loadChildren:
                    "./pages/default/pms_appraiser_setup/pms-appraiser-setup.module#PmsAppraiserSetupModule",
            },
            {
                path: "pms/appraiser/list",
                loadChildren:
                    "./pages/default/pms_appraiser_list/pms-appraiser-list.module#PmsAppraiserListModule",
            },
            {
                path: "reports/employee_attrition_report",
                loadChildren:
                    "./pages/default/reports/employee_attrition_report/employeeAttritionReport.module#EmployeeAttritionReportModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "organization_setup_excel",
                loadChildren:
                    "./pages/default/organization_setup_excel/organizationSetupExcel.module#OrganizationSetupExcelModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "employee/update_employee_excel",
                loadChildren:
                    "./pages/default/employee/update_employee_excel/updateEmployeeExcel.module#UpdateEmployeeExcelModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "man_power_budget_excel",
                loadChildren:
                    "./pages/default/man_power_budget_excel/manPowerBudgetExcel.module#ManPowerBudgetExcelModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "man_power_budget_list",
                loadChildren:
                    "./pages/default/man_power_budget_list/manPowerBudgetList.module#ManPowerBudgetListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "man_power_budget_excel",
                loadChildren:
                    "./pages/default/man_power_budget_excel/manPowerBudgetExcel.module#ManPowerBudgetExcelModule",
                // "canActivate": [AccessGaurdService]
            },
            {
                path: "man_power_budget_list",
                loadChildren:
                    "./pages/default/man_power_budget_list/manPowerBudgetList.module#ManPowerBudgetListModule",
                // "canActivate": [AccessGaurdService]
            },
            {
                path: "organization/global",
                loadChildren:
                    "./pages/default/organization_list_global/organizationList.module#OrganizationListModule",
                // "canActivate": [AccessGaurdService]
            },

            {
                path: "fingerprint_id_merge",
                loadChildren:
                    "./pages/default/fingerprint_id_marge/fingerprint_id_marge.module#FingerPrintIdModule",
                // "canActivate": [AccessGaurdService]
            },
            {
                path: "reports/chart_reports",
                loadChildren:
                    "./pages/default/reports/chart_reports/chartReports.module#ChartReportsModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "employee/create_employee/education_info_excel",
                loadChildren:
                    "./pages/default/employee/create_employee/education_info_excel/educationInfoExcel.module#EducationInfoExcelModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "employee/create_employee/experience_info_excel",
                loadChildren:
                    "./pages/default/employee/create_employee/experience_info_excel/experienceInfoExcel.module#ExperienceInfoExcelModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "education_concentration",
                loadChildren:
                    "./pages/default/education_concentration/educationConcentration.module#EducationConcentrationModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "education_board_list",
                loadChildren:
                    "./pages/default/education_board_list/educationBoardList.module#EducationBoardListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "education_level_list",
                loadChildren:
                    "./pages/default/education_level_list/educationLevelList.module#EducationLevelListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "education_institute_master",
                loadChildren:
                    "./pages/default/education_institute_master/educationInstituteMaster.module#EducationInstituteMasterModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "education_institute_list",
                loadChildren:
                    "./pages/default/education_institute_list/educationInstituteList.module#EducationInstituteListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "education_exam_title_list",
                loadChildren:
                    "./pages/default/education_exam_title_list/educationExamTitleList.module#EducationExamTitleListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "reports/bonus_list_report",
                loadChildren:
                    "./pages/default/bonus_list_project/projectBonusList.module#ProjectBonusListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "reports/bonus_statement_report_bank",
                loadChildren:
                    "./pages/default/reports/bonus_statement_bank/bonusStatementBank.module#BonusStatementBankModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "reports/bonus_statement_report_cash",
                loadChildren:
                    "./pages/default/reports/bonus_statement_cash/bonusStatementCash.module#BonusStatementCashModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "pay_structure/excel_setup",
                loadChildren:
                    "./pages/default/pay_structure_setup_excel/payStructureSetupExcel.module#PayStructureSetupExcelModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "tax_template",
                loadChildren:
                    "./pages/default/tax_template/taxTemplate.module#TaxTemplateModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "tax_template_list",
                loadChildren:
                    "./pages/default/tax_template_list/taxTemplateList.module#TaxTemplateListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "tax_calculation",
                loadChildren:
                    "./pages/default/tax_calculation/taxCalculation.module#TaxCalculationModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "tax_recalculation",
                loadChildren:
                    "./pages/default/tax_recalculation/taxRecalculation.module#TaxRecalculationModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "tax_challan_excel_create",
                loadChildren:
                    "./pages/default/tax_challan_excel_create/taxChallanExcelCreate.module#TaxChallanExcelCreateModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "tax_challan_entry",
                loadChildren:
                    "./pages/default/tax_challan_entry/taxChallanEntry.module#TaxChallanEntryModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "tax_challan_list",
                loadChildren:
                    "./pages/default/tax_challan_list/taxChallanList.module#TaxChallanListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "tax_certificate",
                loadChildren:
                    "./pages/default/tax_certificate/taxCertificate.module#TaxCertificateModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "leaveApplicationExcel",
                loadChildren:
                    "./pages/default/leave_application_excel/leaveApplicationExcel.module#LeaveApplicationExcelModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "country/list",
                loadChildren:
                    "./pages/default/country_list/countryList.module#CountryListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "organization/edit",
                loadChildren:
                    "./pages/default/organization_list_edit/organizationListEdit.module#OrganizationListEditModule",
                // "canActivate": [AccessGaurdService]
            },
            {
                path: "provident_fund_template",
                loadChildren:
                    "./pages/default/provident_fund_template/providentFundTemplate.module#ProvidentFundTemplateModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "provident_fund_template_list",
                loadChildren:
                    "./pages/default/provident_fund_template_list/providentFundTemplateList.module#ProvidentFundTemplateListModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "provident_fund_setup",
                loadChildren:
                    "./pages/default/provident_fund_setup/providentFundSetup.module#ProvidentFundSetupModule",
                canActivate: [AccessGaurdService],
            },
            {
                path: "provident_fund_setup_list",
                loadChildren:
                    "./pages/default/provident_fund_setup_list/providentFundSetupList.module#ProvidentFundSetupListModule",
                canActivate: [AccessGaurdService],
            },

            {
                path: "csv_file_upload",
                loadChildren:
                    "./pages/default/csv_file_upload/csvFileUpload.module#CsvFileUploadModule",
                // canActivate: [AccessGaurdService],
            },
            {
                path: "fiscal_year_list",
                loadChildren:
                    "./pages/default/fiscal_year_list/fiscalYearList.module#FiscalYearListModule",
                canActivate: [AccessGaurdService],
            },

            // {
            //     "path": "overtime_setup_flat",
            //     "loadChildren": ".\/pages\/default\/overtime_setup_flat\/overtime_setup_flat.module#OvertimeSetupFlatModule",
            //     "canActivate": [AccessGaurdService]
            // },
            // {
            //     "path": "manual_overtime",
            //     "loadChildren": ".\/pages\/default\/manual_overtime\/manual_overtime.module#ManualOvertimeModule",
            //     "canActivate": [AccessGaurdService]
            // },

            // {
            //     "path": "late_attendance_arrear_setup",
            //     "loadChildren": ".\/pages\/default\/late_attendance_arrear_setup\/late_attendance_arrear_setup.module#LateAttendanceArrearSetupModule",
            //     "canActivate": [AccessGaurdService]
            // },

            // {
            //     "path": "project_list",
            //     "loadChildren": ".\/pages\/default\/project_list\/project_list.module#ProjectListModule",
            //     // "canActivate": [AccessGaurdService]
            // },
            // {
            //     "path": "salaryandbonus",
            //     "loadChildren": ".\/pages\/default\/salaryandbonus\/salaryandbonus.module#SalaryAndBonusModule",
            //     "canActivate": [AccessGaurdService]
            // },
            // {
            //     "path": "advance_deduction_history",
            //     "loadChildren": ".\/pages\/default\/advance_deduction_history\/advance_deduction_history.module#AdvanceDeductionHistoryModule",
            //     "canActivate": [AccessGaurdService]
            // },
            // {
            //     "path": "organogram",
            //     "loadChildren": ".\/pages\/default\/organogram\/organogram.module#OrganogramModule",
            //    // "canActivate": [AccessGaurdService]
            // },
            // {
            //     "path": "bank_master",
            //     "loadChildren": ".\/pages\/default\/bank_master\/bank_master.module#BankMasterModule",
            //     "canActivate": [AccessGaurdService]
            // },
            // {
            //     "path": "business_unit/account_master",
            //     "loadChildren": ".\/pages\/default\/business_unit_account_master\/business_unit_account_master.module#BusinessUnitAccountMasterModule",
            //     "canActivate": [AccessGaurdService]
            // },
            // {
            //     "path": "pay_structure/template",
            //     "loadChildren": ".\/pages\/default\/pay_structure_template\/payStructureTemplate.module#PayStructureTemplateModule",
            //     "canActivate": [AccessGaurdService]
            // },
            // {
            //     "path": "pay_slip_generation/list_employee",
            //     "loadChildren": ".\/pages\/default\/pay_slip_generation_details_list\/generatedDetailsList.module#GeneratedDetailsListModule",
            //     "canActivate": [AccessGaurdService]
            // },
            // {
            //     "path": "pay_slip_generation/list_project",
            //     "loadChildren": ".\/pages\/default\/pay_slip_list_project\/projectPaySlipList.module#ProjectPaySlipListModule",
            //     "canActivate": [AccessGaurdService]
            // },
            // {
            //     "path": "transfer/list",
            //     "loadChildren": ".\/pages\/default\/transfer_list\/transferList.module#TransferListModule",
            //     "canActivate": [AccessGaurdService]
            // },

            // {
            //     "path": "reports/monthly_salary_statement",
            //     "loadChildren": ".\/pages\/default\/reports/monthly_salary_statement\/monthly_salary_statement.module#MonthlySalSatModule",
            //     "canActivate": [AccessGaurdService]
            // },
            // {
            //     "path": "reports/setup_report",
            //     "loadChildren": ".\/pages\/default\/reports/setup_report\/setupReport.module#SetupReportModule",
            // },
            // {
            //     "path": "leaveapplication_list_summarry",
            //     "loadChildren": ".\/pages\/default\/leaveapplication_list_summarry\/leaveapplication_list_summarry.module#LeaveApplicationListSummaryModule",
            //     "canActivate": [AccessGaurdService]
            // },
            // {
            //     "path": "organization_setup_new",
            //     "loadChildren": ".\/pages\/default\/organization_setup\/organizationSetup.module#OrganizationSetupModule",
            //     "canActivate": [AccessGaurdService]
            // },
            // {
            //     "path": "present_offday_template",
            //     "loadChildren": ".\/pages\/default\/present_offday_template\/presentOffDayTemplate.module#PresentOffDayTemplateModule",

            // },
            // {
            //     "path": "overstay_template",
            //     "loadChildren": ".\/pages\/default\/overstay_template\/overstayTemplate.module#OverstayTemplateModule",

            // },
            // {
            //     "path": "night_stay_template_list",
            //     "loadChildren": ".\/pages\/default\/night_stay_template_list\/nightStayTemplateList.module#NightStayTemplateListModule",
            // },
            // {
            //     "path": "present_offday_template_list",
            //     "loadChildren": ".\/pages\/default\/present_offday_template_list\/presentOffdayTemplateList.module#PresentOffdayTemplateListModule",
            // },
            // {
            //     "path": "overtime_template_list",
            //     "loadChildren": ".\/pages\/default\/overtime_template_list\/overTimeTemplateList.module#OverTimeTemplateListModule",
            // },
            // {
            //     "path": "overtime_monthly_entry_list",
            //     "loadChildren": ".\/pages\/default\/overtime_monthly_entry_list\/overtimeMonthlyEntryList.module#OverTimeMonthlyEntryListModule",
            // },
            // {
            //     "path": "night_stay_monthly_entry_list",
            //     "loadChildren": ".\/pages\/default\/night_stay_monthly_entry_list\/nightStayMonthlyEntryList.module#NightStayMonthlyEntryListModule",
            // },
            // {
            //     "path": "present_offday_monthly_entry_list",
            //     "loadChildren": ".\/pages\/default\/present_offday_monthly_entry_list\/presentOffdayMonthlyEntryList.module#PresentOffdayMonthlyEntryListModule",
            // },
            // {
            //     "path": "night_stay_template",
            //     "loadChildren": ".\/pages\/default\/nightstay_template\/overstayTemplate.module#OverstayTemplateModule",
            // },
            // {
            //     "path": "night_stay_setup",
            //     "loadChildren": ".\/pages\/default\/nightstay_setup\/nightStaySetup.module#NightStaySetupModule",
            // },
            // {
            //     "path": "overtime_template_setup_list",
            //     "loadChildren": ".\/pages\/default\/overtime_template_setup_list\/overtime_template_setup_list.module#OvertimeTemplateSetupListModule",
            //     "canActivate": [AccessGaurdService]
            // },
            // {
            //     "path": "employee_farewell",
            //     "loadChildren": ".\/pages\/default\/employee_farewell\/employee_farewell.module#EmployeeFarewellModule",
            //     "canActivate": [AccessGaurdService]
            // },
            // {
            //     "path": "job_desciption",
            //     "loadChildren": ".\/pages\/default\/job_description\/jobDesc.module#JobDescriptionModule",
            //     "canActivate": [AccessGaurdService]
            // },
            // {
            //     "path": "job_posting",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            //     "canActivate": [AccessGaurdService]
            // },
            // {
            //     "path": "manpower_planning",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "recruitement_selection",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "placement",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "orientation",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "socialization",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "training",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "development",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "performance_management",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "career_planning",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "promotions",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "separation",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "departmental_budget",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "overhead_optimization",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "employee_policies",
            //     "loadChildren": ".\/pages\/default\/employee_policies\/employeePolicies.module#EmployeePolicyModule",
            // },
            // {
            //     "path": "message_center",
            //     "loadChildren": ".\/pages\/default\/message_center\/messageCenter.module#MessageCenterModule",
            // },
            // {
            //     "path": "employee_decipline",
            //     "loadChildren": ".\/pages\/default\/employee_discipline\/employeeDiscipline.module#EmployeeDisciplineModule",
            // },
            // {
            //     "path": "employee_grievances",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "conflict_management",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "employee_counselling",
            //     "loadChildren": ".\/pages\/default\/employee_counselling\/employeeCounselling.module#EmployeeCounsellingModule",
            // },
            // {
            //     "path": "employee_wellness",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "record_keeping",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "hr_audit",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "policy_development",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "transport_registration",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "transport_repair",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "transport_tracking",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "transport_management",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "transport_procurement",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "office_open_close",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "front_desk_management",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "meeting_rooms_management",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "housekeeping",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "internal_repair",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "cafeteria_management",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "office_purchase",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "office_security",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "fire_fighting",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "fire_aid",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "top_management_service",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "printing_management",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "special_works",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "guest_house_management",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "renting_house",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "store_management",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "transport_procurement",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "transport_procurement",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "transport_procurement",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "transport_procurement",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "transport_procurement",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "transport_procurement",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "transport_procurement",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "transport_procurement",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "monthly_expense",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "employee_accomodation",
            //     "loadChildren": ".\/pages\/default\/employee_accomodation\/employeeAccomodation.module#EmployeeAccomodationModule",
            // },
            // {
            //     "path": "hotel_booking",
            //     "loadChildren": ".\/pages\/default\/hotel_booking\/hotelBooking.module#HotelBookingModule",
            // },
            // {
            //     "path": "travelling_ticket",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "visa_clearence",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "airport_protocol",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "protocol_arrangement",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "visa_process",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "foreigner_entertainment",
            //     "loadChildren": ".\/pages\/default\/job_posting\/jobPost.module#JobPostingModule",
            // },
            // {
            //     "path": "performance_appraisal_form",
            //     "loadChildren": ".\/pages\/default\/performance_appraisal_form\/performance_appraisal_form.module#PerformanceAppraisalFormModule",
            //     // "canActivate": [AccessGaurdService]
            // },
            {
                path: "organogram",
                loadChildren:
                    "./pages/default/organogram_list/organogram_list.module#OrganogramListModule",
                // "canActivate": [AccessGaurdService]
            },
            // {
            //     "path": "event_management",
            //     "loadChildren": ".\/pages\/default\/event_management\/event_management.module#EventManagementModule",
            //     // "canActivate": [AccessGaurdService]
            // },
            // {
            //     "path": "transportation_tickets",
            //     "loadChildren": ".\/pages\/default\/air_train_bus_tickets\/air_train_bus_tickets.module#TransportationTicketsModule",
            //     // "canActivate": [AccessGaurdService]
            // },
            // {
            //     "path": "manpower_mapping",
            //     "loadChildren": ".\/pages\/default\/employee_mapping\/employeeMapping.module#EmployeeMappingModule",
            // },

            // {
            //     "path": "organization_info/organizationInfo/:id",
            //     // "loadChildren": ".\/pages\/default\/employee\/create_employee\/personal\/personal.module#PersonalModule",
            // "canActivate": [AccessGaurdService]
            //     "loadChildren": ".\/pages\/default\/organization_info\/organizationInfo.module#OrganizationInfoModule",
            // "canActivate": [AccessGaurdService]
            // },
            // {
            //     "path": "travel/setup",
            //     "loadChildren": ".\/pages\/default\/travel\/travel.module#TravelModule",
            // "canActivate": [AccessGaurdService]
            // },

            {
                path: "",
                redirectTo: "index",
                pathMatch: "full",
            },
        ],
    },
    {
        path: "snippets/pages/errors/error-1",
        loadChildren:
            "./pages/self-layout-blank/snippets/pages/errors/errors-error-1/errors-error-1.module#ErrorsError1Module",
        // "canActivate": [AccessGaurdService]
    },
    {
        path: "snippets/pages/errors/error-2",
        loadChildren:
            "./pages/self-layout-blank/snippets/pages/errors/errors-error-2/errors-error-2.module#ErrorsError2Module",
        // "canActivate": [AccessGaurdService]
    },
    {
        path: "snippets/pages/errors/error-3",
        loadChildren:
            "./pages/self-layout-blank/snippets/pages/errors/errors-error-3/errors-error-3.module#ErrorsError3Module",
        // "canActivate": [AccessGaurdService]
    },
    {
        path: "snippets/pages/errors/error-4",
        loadChildren:
            "./pages/self-layout-blank/snippets/pages/errors/errors-error-4/errors-error-4.module#ErrorsError4Module",
        // "canActivate": [AccessGaurdService]
    },

    {
        path: "fingerprint_id_merge",
        loadChildren:
            "./pages/self-layout-blank/snippets/pages/errors/errors-error-5/errors-error-5.module#ErrorsError5Module",
        // "canActivate": [AccessGaurdService]
    },
    {
        path: "snippets/pages/errors/error-6",
        loadChildren:
            "./pages/self-layout-blank/snippets/pages/errors/errors-error-6/errors-error-6.module#ErrorsError6Module",
        // "canActivate": [AccessGaurdService]
    },
    {
        path: "**",
        redirectTo: "404",
        pathMatch: "full",
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ThemeRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/theme/theme-routing.module.ts